var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrestIcon = function SvgCrestIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6106_117)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6106_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.24184 18.4325C4.24184 18.4325 8.132 15.4715 8.56658 11.4644C4.56103 11.8997 1.59847 15.7892 1.59847 15.7892H0.0310059V4.23856H1.59847C1.59847 4.23856 4.55878 8.12797 8.56658 8.53482C8.13126 4.55775 4.24184 1.59742 4.24184 1.59742V0H15.7947V1.59667C15.7947 1.59667 11.9053 4.557 11.47 8.53407C15.4755 8.12722 18.4381 4.23781 18.4381 4.23781H20.0055V15.7907H18.4381C18.4381 15.7907 15.477 11.9012 11.47 11.4659C11.9053 15.4715 15.7947 18.434 15.7947 18.434V20.0015H4.24184V18.4325Z",
    fill: "var(--svg-base)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6106_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9708,
    height: 20,
    fill: "var(--svg-contrast)",
    transform: "translate(0.0332031)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6106_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9708,
    height: 20,
    fill: "var(--svg-contrast)",
    transform: "translate(0.0332031)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrestIcon);
export { ForwardRef as ReactComponent };